// extracted by mini-css-extract-plugin
export var container = "_ol-0";
export var dotAnimation = "_ol-2";
export var dotsLoading = "_ol-1";